import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.scss';
import Footer from './components/Footer';
import Login from './components/Login';
import SignUp from './components/SignUp';
import ForgotPassword from './components/ForgotPassword';
import ChangePassword from './components/ChangePassword';
import { AuthProvider } from './contexts/AuthContext';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Dashboard from './components/dashboard/Dashboard';
import Designers from './components/designers/Designers';
import AccountVerification from './components/AccountVerification';
import UserSettings from './components/UserSettings';
import NotFound from './components/NotFound';
import ProjectChat from './components/ProjectChat';
import ProjectDetails from './components/dashboard/ProjectDetails';
gsap.registerPlugin(ScrollTrigger);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/account-verification/:token" element={<AccountVerification />} />
            <Route path="/user-settings" element={<UserSettings />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/project-details" element={<ProjectDetails />} />
            <Route path="/designers" element={<Designers />} />
            <Route path="/project-chat/:id" element={<ProjectChat />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Footer />
    </div>
  );
}

export default App;
